var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { useLastSignRequest } from 'app/domains/esigning/hooks/useLastSignRequest';
import { SendSignRequestReminderDocument } from './mutation.gql';
export const useSendSignRequestReminder = () => {
    const { lastSignRequest } = useLastSignRequest();
    const { id: signRequestId = '' } = lastSignRequest || {};
    const [mutate, result] = useMutation(SendSignRequestReminderDocument, {
        variables: {
            signRequestId,
        },
    });
    const sendReminder = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { data } = yield mutate();
        // eslint-disable-next-line no-underscore-dangle
        if (((_a = data === null || data === void 0 ? void 0 : data.sendSignRequestReminder) === null || _a === void 0 ? void 0 : _a.__typename) === 'SendSignRequestReminderRejectionList') {
            throw new Error();
        }
    });
    return [sendReminder, result];
};
